<template>
  <div class="sm-credit-card">
    <span>
      {{label}}
      <svg 
        v-if="card.number && !errors.first('credit-card-number')"
        xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        fill="none" 
        viewBox="0 0 16 16" 
        style="vertical-align:middle;margin-left:4px;"
      >
        <circle cx="8" cy="8" r="8" fill="#19CB76"/>
        <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.969 8.158l2.285 2.285 3.779-4.285"/>
      </svg>
    </span>
    <div class="sm-credit-card-inner">
      <div 
        class="sm-input-text-wrap sm-credit-card-number"
        :class="{
          'error': cardErrors.length
        }"
      >
        <i 
          class="sm-credit-card-brand"
          :class="`card-brand card-brand-${iconBrand}`"
        ></i>
        <input 
          type="credit-card" 
          ref="credit-card-number"
          placeholder="Card Number" 
          name="credit-card-number" 
          autocomplete="cc-number" 
          class="sm-input-text"
          maxlength="19"
          v-model="number_mask"
          v-validate="'credit_card'"
          @blur="prepareNumber"
        >
      </div>

      <div 
        class="sm-input-text-wrap"
        :class="{
          'error': cardErrors.length
        }"
      >
        <input 
          type="text"
          ref="credit-card-exp"
          :placeholder="!isMobile ? 'MM / YYYY' : 'MM/YYYY'"
          name=""
          autocomplete="cc-exp"
          class="sm-input-text"
          maxlength="7"
          v-model="cardExpires"
          @keyup.delete="deleteSlash = true"
          @blur="parceExpires"
        >
      </div>

      <div 
        class="sm-input-text-wrap"
        :class="{
          'error': cardErrors.length
        }"
      >
        <input 
          type="password" 
          placeholder="CVV" 
          name="" 
          autocomplete="cc-csc" 
          class="sm-input-text"
          v-model="card.cvc"
          @blur="handleCvc"
        >
      </div>
      <span
        v-if="cardErrors.length"
        class="sm-error sm-tiny sm-credit-card-error"
      >{{cardErrors[0].msg}}</span>
    </div>
  </div>
</template>

<script>
import Cleave from 'cleave.js';
import InputText from '@/components/InputText';
import { mapGetters } from 'vuex';
import { getPaymentBrandIcon } from '@/utils/pymnt-card';

export default {
  name: 'creadit-card',
  components: {
    'input-text': InputText
  },
  data() {
    return {
      brand: '',
      deleteSlash: false,
      number_mask: this.value.number,
      card: {
        number: '',
        expiration: {
          month: this.value.expiration.month,
          year: this.value.expiration.year
        },
        cvc: this.value.cvc
      },
      cardExpires: ''
    }
  },
  props: {
    label: {
      type: String,
      default: 'Credit or debit card'
    },
    value: {
      type: Object,
      default: () => {
        return {
          number: '',
          expiration: {
            month: '',
            year: ''
          },
          cvc: '',
        }
      }
    },
    error: {
      type: String,
      default: ''
    },
  },
  mounted () {
    const that = this;
    new Cleave(this.$refs['credit-card-number'], {
      creditCard: true,
      onCreditCardTypeChanged(type) {
        that.brand = type;
      }
    });
    new Cleave(this.$refs['credit-card-exp'], {
      date: true,
      datePattern: ['m', 'Y']
    });
  },
  methods: {
    parceExpires() {
      if (this.$cardFormat.validateCardExpiry(this.cardExpires)) {
        this.errors.remove('expiry_date');

        let exp = this.cardExpires.split('/');

        if (exp[1].length == 2) {
          exp[1] = `20${exp[1]}`;
          this.cardExpires = `${exp[0]}/${exp[1]}`;
        }

        this.card.expiration.month = exp[0];
        this.card.expiration.year = exp[1];

        this.$emit('input', this.card);
      } else {
        this.errors.add({
          field: 'expiry_date',
          msg: 'Enter valid Expiration Date in MM/YYYY format'
        });
      }
    },
    prepareNumber() {
      if (this.$cardFormat.validateCardNumber(this.number_mask)) {
        this.errors.remove('credit_card');

        this.card.number = this.number_mask.split(' ').join('');

        this.$emit('input', this.card);
      } else {
        this.errors.add({
          field: 'credit_card',
          msg: 'Invalid Credit Card Number'
        });
      }
    },
    handleCvc() {
      if (this.$cardFormat.validateCardCVC(this.card.cvc)) {
        this.errors.remove('cvc_code');

        this.$emit('input', this.card);
      } else {
        this.errors.add({
          field: 'cvc_code',
          msg: 'Invalid CVC Code'
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    iconBrand() {
      return getPaymentBrandIcon(this.brand);
    },
    cardErrors() {
      return this.errors.items.filter(err => err.vmId == this._uid);
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/general/mixins.scss';
  @import '@/assets/scss/framework/scss-variables.scss';
  @import '@/assets/scss/components/_credit-card.scss';
  @import "@/assets/scss/components/_cards-brand.scss";
</style>